import { useReducer } from "react";
import TrainingPlansContext, { initialState } from "./TrainingPlansContext";
import TrainingPlansReducer from "./TrainingPlansReducer";

const TrainingPlansState = (props: any) => {
  const [state, dispatch] = useReducer(TrainingPlansReducer, initialState);
  return (
    <TrainingPlansContext.Provider value={{ state, dispatch }}>
      {props.children}
    </TrainingPlansContext.Provider>
  );
};
export default TrainingPlansState;
